import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PagePanel, OutlineWarningIcon, Box } from 'edenred-ui';
import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import { EmptyState } from '@epi-shared/components';

function ContactDeleted({ dispatch }) {
  const { t } = useTranslation();

  return (
    <PagePanel>
      <Box
        mt={6}
        minHeight={600}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <EmptyState
          icon={<OutlineWarningIcon />}
          title={t('sign_up.contact_deleted_heading')}
          description={t('sign_up.contact_deleted_description')}
          btnText={t('sign_up.contact_deleted_btn')}
          btnOnClick={() => dispatch(goToPage(routerPaths.home))}
        />
      </Box>
    </PagePanel>
  );
}

ContactDeleted.propTypes = {
  dispatch: PropTypes.func.isRequired
};

const ConnectedContactDeleted = connect()(ContactDeleted);

export { ConnectedContactDeleted as ContactDeleted };
